import { useTheme } from '../../context/ThemeContext';
import { Link } from 'react-router-dom';
import { MascotSmall } from '../Mascot';

export const Footer = () => {
  const { isDark } = useTheme();
  
  return (
    <footer 
      className={`py-12 px-6 ${isDark ? 'bg-black' : 'bg-white'}`}
      data-testid="footer"
    >
      <div className="max-w-[980px] mx-auto">
        {/* Top row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 mb-8">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <MascotSmall className="w-6 h-6" />
            <span className={`text-[15px] font-semibold tracking-[-0.01em] ${
              isDark ? 'text-[#f5f5f7]' : 'text-[#1d1d1f]'
            }`}>
              <span className="text-[#81d8d0]">Skip</span>ya
            </span>
          </div>
          
          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <Link
              to="/mentions-legales"
              className={`text-[12px] transition-colors ${
                isDark ? 'text-[#86868b] hover:text-[#f5f5f7]' : 'text-[#6e6e73] hover:text-[#1d1d1f]'
              }`}
              data-testid="footer-link-legal"
            >
              Mentions légales
            </Link>
            <Link
              to="/confidentialite"
              className={`text-[12px] transition-colors ${
                isDark ? 'text-[#86868b] hover:text-[#f5f5f7]' : 'text-[#6e6e73] hover:text-[#1d1d1f]'
              }`}
              data-testid="footer-link-privacy"
            >
              Confidentialité
            </Link>
            <Link
              to="/contact"
              className={`text-[12px] transition-colors ${
                isDark ? 'text-[#86868b] hover:text-[#f5f5f7]' : 'text-[#6e6e73] hover:text-[#1d1d1f]'
              }`}
              data-testid="footer-link-contact"
            >
              Contact
            </Link>
            <a
              href="/#securite"
              className={`text-[12px] transition-colors ${
                isDark ? 'text-[#86868b] hover:text-[#f5f5f7]' : 'text-[#6e6e73] hover:text-[#1d1d1f]'
              }`}
              data-testid="footer-link-security"
            >
              Sécurité
            </a>
            <Link
              to="/etat-du-projet"
              className={`text-[12px] transition-colors ${
                isDark ? 'text-[#86868b] hover:text-[#81d8d0]' : 'text-[#6e6e73] hover:text-[#81d8d0]'
              }`}
              data-testid="footer-link-recap"
            >
              État du projet
            </Link>
          </div>
        </div>
        
        {/* Bottom row */}
        <div className={`pt-8 border-t text-center ${isDark ? 'border-[#1d1d1d]' : 'border-[#e8e8ed]'}`}>
          <p className={`text-[12px] ${isDark ? 'text-[#6e6e73]' : 'text-[#86868b]'}`}>
            © {new Date().getFullYear()} Skipya — Hannah Taieb EI. Tous droits réservés.
          </p>
          <p className={`text-[12px] mt-1 ${isDark ? 'text-[#6e6e73]' : 'text-[#86868b]'}`}>
            Un projet accompagné par <span className="text-[#81d8d0]">Coach Digital Paris</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
